import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import Select from "react-select";
import { OptionImage } from "../../product/style";

const SectionColorsDialog = ({
  group,
  tableManager,
  colorIdentifiers,
  updateSectionProperties,
  mutateCurrentRoom,
  isAdmin,
  setCurrentTab,
}) => {
  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {colorIdentifiers.map((identifier, index) => {
          const property = group.property_list.find(
            (e) => e.identifier === identifier
          );

          return (
            <div onClick={(e) => e.stopPropagation()}>
              <p className="grey_letter mb-1">{property.name}</p>
              {property.is_editable ? (
                <Select
                  autoFocus={index === 0 ? true : false}
                  className="list-summary-select"
                  key={index}
                  value={
                    property.options.find((option) => option.selected) || null
                  }
                  isDisabled={!property.is_editable}
                  onChange={(selectedOption) => {
                    if (selectedOption.identifier === "__add_more__") {
                      if (setCurrentTab) {
                        setCurrentTab("materials", "colors");
                      } else {
                        tableManager.clear();
                      }
                      return;
                    }
                    property.options.forEach((o) => {
                      o.selected = o.identifier == selectedOption.identifier;
                    });
                    mutateCurrentRoom();
                    updateSectionProperties({
                      id: group.id,
                      propIdentifier: property.identifier,
                      optionIdentifier: selectedOption.identifier,
                    });
                  }}
                  options={[
                    ...property.options.map((option, optionIndex) => {
                      option.value = option.name;
                      option.label = (
                        <div key={optionIndex}>
                          {option.image && (
                            <OptionImage
                              src={option.image}
                              alt={option.name}
                              className="border border-dark rounded-circle me-2"
                            />
                          )}
                          {option.name}
                        </div>
                      );

                      option.key = index;

                      return {
                        value: option.name,
                        label: option.name,
                        ...option,
                      };
                    }),
                    {
                      value: "... add more colors",
                      label: "... add more colors",
                      identifier: "__add_more__",
                      key: `add-more-colors-${index}`,
                    }
                  ]}
                />
              ) : (
                <div className="mt-1 text-disabled">
                  {property.options.find((option) => option.selected)?.name ||
                    "No Value"}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <TableDialogFooter>
      <TableDialogBtn
        onClick={(e) => {
          e.stopPropagation();
          tableManager.clear();
        }}
        className="mt-3"
      >
        Done
      </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default SectionColorsDialog;
